import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Warranty = ({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = 1,
  ...props
}) => (
  <IconBase viewBox='0 0 12 16' {...props}>
    <Path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.28908 7.10081L1.98899 8.0136L2.13947 9.14862C2.22244 9.77732 2.71561
       10.2729 3.3439 10.3589L4.48242 10.5105L5.39347 11.2046C5.89785 11.5902
       6.59803 11.5902 7.10241 11.2046L8.01463 10.5082L9.15081 10.3577C9.78077
       10.274 10.2765 9.77854 10.3605 9.14862L10.5121 8.0101L11.212 7.09847C11.5971
        6.59432 11.5971 5.89484 11.212 5.39069L10.5121 4.4779L10.3617 3.34288C10.277
         2.71304 9.78085 2.21804 9.15081 2.13495L8.01229 1.9833L7.10124 1.28923C6.59686
          0.903592 5.89668 0.903592 5.3923 1.28923L4.48008 1.9833L3.3439 2.13378C2.7144
           2.21797 2.21927 2.71333 2.13539 3.34288L1.98374 4.48139L1.28908
           5.39303C0.90364 5.89704 0.90364 6.59679 1.28908 7.10081Z'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M8.57818 5.07422L5.5035 7.98929L3.91406 6.54102'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M3.625 10.8398V14.9953L6.25 13.9117L8.87464 14.9953V10.8398'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

Warranty.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.number,
}

export default Warranty
